<template>
  <div class="SidebarRelatedItems">
    <h3 class="heading">{{ heading }}</h3>
    <div v-for="resourceLink in resourceLinks"
      :key="resourceLink._id"
      class="relatedItem"
    >
      <a :href="getResourceArticlePath(resourceLink, context.articlePathPattern)" class="resourceLink">
        {{ resourceLink.title }}
      </a>
    </div>
    <a v-if="viewMoreLink" :href="viewMoreLink.path" class="viewMoreLink">
      {{ viewMoreLink.text }}
    </a>
  </div>
</template>

<script setup>
import { inject } from 'vue'
import { getResourceArticlePath } from '../lib/article-util'

const context = inject('context')

const { heading, resourceLinks, viewMoreLink } = defineProps({
  heading: {
    type: String,
    default: '',
  },
  resourceLinks: {
    type: Array,
    default: () => [],
  },
  viewMoreLink: {
    type: Object,
    default: null,
  },
})
</script>

<style scoped>

.SidebarRelatedItems {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-5);
  border: thin solid var(--hairline-color);
  border-radius: 6px;
  padding: var(--spacing-8) var(--spacing-6) var(--spacing-7);
}

.heading {
  font-weight: 400;
  font-size: var(--font-size-1);
  color: #9A9C9F;
}

.relatedItem {
  padding-bottom: var(--spacing-5);
  border-bottom: thin solid var(--hairline-color);
}

.resourceLink {
  font-weight: 400;
  font-size: var(--font-size-2);
  line-height: 1.5;
  color: var(--text-color-black);
  transition: color 0.15s;
}

.resourceLink:hover {
  color: var(--brand-color);
}

.viewMoreLink {
  font-weight: 500;
  font-size: var(--font-size-1);
  color: var(--brand-color);
}
</style>
